import * as types from './types'

export default {
  [types.SET_TRANSACTIONS](state, data) {
    state.transactions = data || []
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/billing/mutations.js